<template>
  <input-form
    component-name="form-password"
    ref="tpl_root"
    :use-mandatory-fields-warning="true"
    :success-callback="handleSuccess"
    :success-message="$t.texts.password_updated"
    :success-btn="successButton"
    :submit-callback="handleSubmit"
    :value="initialValue"
    :submit-title="$t.labels.confirm_new_password"
    @update:value="handleUpdate"
  >
    <input-password :use-confirm="true" class="w-full" />
  </input-form>
</template>

<script setup>
import { useUserStore } from "@/stores/user";

const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: function (value) {
      return ["reset", "change"].indexOf(value) !== -1;
    },
  },
});

const tpl_root = templateRef("tpl_root");
const nuxtApp = useNuxtApp();
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

const successButton = computed(() => {
  return props.variant == "change"
    ? {
        title: nuxtApp.$t.labels.back_to_profile,
        action: {
          to: `/account/profile/info`,
        },
      }
    : {
        title: nuxtApp.$t.labels.signin,
        action: {
          to: `/signin`,
        },
      };
});

const initialValue = ref({
  email: userStore.user.email || "",
});

function handleSuccess(data) {
  // if (props.variant === "reset") {
  //   // router.push(`/${route.params.country}/${route.params.locale}/signin`);
  // } else if (props.variant === "change" && userStore.user.logged) {
  //   router.push(
  //     `/${route.params.country}/${route.params.locale}/account/profile/info`
  //   );
  // } else router.push(`/${route.params.country}/${route.params.locale}/`);
}

function handleUpdate(data) {
  console.log("handleUpdate", data);
}

async function handleSubmit(fields) {
  /* 
      variant "reset" (recupero pw da non loggato)
        - email (ricevuto via email link)
        - token (ricevuto via email link)
        - password (inserita nella form)
  */

  const data = {
    email: route.query.email,
    token: route.query.token,
    password: fields.password_group.password,
  };

  console.log("passwordChange", data, "fields", fields);

  return userStore
    .passwordChange(data)
    .then((response) => {
      if (!response) {
        tpl_root.value.handleErrors([nuxtApp.$t.labels.something_went_wrong]);
      }
      const { status, error } = response;

      if (error) {
        tpl_root.value.handleErrors([nuxtApp.$t.labels.something_went_wrong]);
      }

      return response;
    })
    .catch((error) => {
      console.log("error", error);
      tpl_root.value.handleErrors([nuxtApp.$t.labels.something_went_wrong]);
    });
}
</script>
